<template>
	<div>
		<div class="card mb-0 shadow" v-if="!editar_atendimento">
			<div class="card-body">
				<div class="tab-content">
					<div class="animate__animated animate__fadeIn">
						<div class="row">
							<div class="col-12">
								<h4 class="font-weight-bold">Atendimentos/Cronograma</h4>
							</div>
							<div class="col-md-12">
								<div v-if="!novo_atendimento && !showImpressaoAcompanhamentos" class="animate__animated animate__fadeIn">
									<div class="row" v-if="!loadingAtendimentos">
										<div class="col-12">
											<div class="d-flex align-items-center justify-content-between mb-4">
												<div>
													<button class="btn btn-sm btn-primary" @click="novo_atendimento = true">
														<i class="fas fa-plus-square" />
														{{ $t("Cadastrar") }}
													</button>
													<button
														class="btn btn-sm btn-primary"
														@click.prevent="$bvModal.show('relacionar-model')"
													>
														<i class="mdi mdi-connection" />
														{{ $t("Relacionar com um existente") }}
													</button>
												</div>
												<div class="d-flex align-items-center justify-content-between">
													<div class="input-group mb-3">
														<b-input
															:placeholder="$t('Type to search')"
															class="form-control search-input"
															type="text"
															v-model="search"
															v-on:change="getAtendimentos"
															aria-describedby="input-search"
														/>
														<div class="input-group-append" role="button">
															<span class="input-group-text" id="input-search"
																><i class="fas fa-search search-icon"
															/></span>
														</div>
													</div>
													<div>
                            <button class="btn btn-success btn-sm ml-4" @click="gerarImpressao()">
                              Gerar Impressão
                            </button>
                          </div>
												</div>
											</div>
										</div>
									</div>
									<div class="row">
										<load mode="table" v-if="loadingAtendimentos" />
										<div class="col-12" v-else>
											<ListAtendimentos
												:itens="AtendimentosList"
												:pagination="pagination"
												:page.sync="page"
												:porpagina.sync="perPage"
												@changePage="changePage"
												@reload="getAtendimentos"
												@editar="
													atendimentoSelected = $event;
													editar_atendimento = true;
												"
											/>
										</div>
									</div>
								</div>
								<NovoAtendimento
									v-else-if="novo_atendimento && !showImpressaoAcompanhamentos"
									:familia="familia"
									:morph="{ id: acompanhamento.id, type: 'Paf' }"
									@voltar="novo_atendimento = false"
									@reload="
										getAtendimentos();
										novo_atendimento = false;
									"
								/>
								<ImpressaoAtendimentos
									v-else-if="showImpressaoAcompanhamentos"
									:familia_id="familia.id"
									:morph="{ id: acompanhamento.id, type: 'Paf' }"
									@voltar="showImpressaoAcompanhamentos = false"
								/>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<EditarAtendimento
			v-else
			:morph="true"
			:morph-atendimento-id="atendimentoSelected"
			@voltar="editar_atendimento = false"
		/>
		<ModalRelacionar
			table="atendimentos"
			text="Atendimento"
			:paf-id="acompanhamento.id"
			:familia-id="familia.id"
			label="Digite ou selecione o Protocolo"
			@reload="getAtendimentos"
		/>
	</div>
</template>
<script>
import NovoAtendimento from "../../../../../../Atendimento/Resources/assets/js/Add";
import EditarAtendimento from "../../../../../../Atendimento/Resources/assets/js/Edit";
import ListAtendimentos from "./lista/ListAtendimentos";
import ModalRelacionar from "../ModalRelacionar";
import ImpressaoAtendimentos from "../../../../../../Atendimento/Resources/assets/js/ImpressaoAtendimentos.vue";
export default {
	props: ["acompanhamento"],
	components: {
		NovoAtendimento,
		EditarAtendimento,
		ModalRelacionar,
		ListAtendimentos,
		ImpressaoAtendimentos,
	},
	name: "Atendimentos",
	metaInfo() {
		return {
			title: this.$i18n.t("Atendimentos"),
		};
	},
	data() {
		return {
			familia: {},
			novo_atendimento: false,
			editar_atendimento: false,
			TipoAtendimentosList: [],
			AtendimentosList: [],
			atendimentoSelected: "",
			page: 1,
			search: "",
			perPage: 10,
			loadingAtendimentos: true,
			loading: true,
			pagination: {
				currentPage: 0,
				perPage: 0,
				total: 0,
				totalPages: 0,
			},
			showImpressaoAcompanhamentos: false,
		};
	},
	mounted() {
		// this.$route.query.familia_id = this.$route.params.id;
		if (typeof this.$route.query.item === "object") {
			this.familia = this.$route.query.item;
		} else {
			this.getFamilia();
		}
		this.getAtendimentos();
	},
	methods: {
		getAtendimentos() {
			this.loadingAtendimentos = true;
			axios
				.get("api/dashboard/atendimentos", {
					params: {
						id: this.$route.query.familia_id,
						morph_type: "Paf",
						morph_id: this.acompanhamento.id,
						page: this.page,
						search: this.search,
						perPage: this.perPage,
					},
				})
				.then((response) => {
					this.AtendimentosList = response.data.data;
					this.pagination = response.data.pagination;

					if (this.pagination.totalPages < this.pagination.currentPage) {
						this.page = this.pagination.totalPages;
						this.getAtendimentos();
					} else {
						this.loadingAtendimentos = false;
					}
				})
				.catch(() => {
					this.loadingAtendimentos = false;
				});
		},
		changePage(page) {
			if (page > 0 && page <= this.pagination.totalPages && page !== this.page) {
				this.page = page;
				this.getAtendimentos();
			}
		},

		redirectAtendimento(id) {
			this.$router.push({
				path: `/dashboard/atendimentos/edit/${id}`,
				query: { familia_id: this.$route.query.familia_id },
			});
		},
		getFamilia() {
			axios
				.get("api/dashboard/familias/" + this.$route.query.familia_id)
				.then((response) => {
					this.familia = response.data.data;
					this.$route.query.familia_id = this.familia.id;
					this.loading = false;
				})
				.catch(() => {
					this.$router.push("/dashboard/familias");
				});
		},
		gerarImpressao() {
      this.showImpressaoAcompanhamentos = true;
    }
	},
};
</script>
